import { Directive } from '@angular/core';

@Directive({
  selector: '[adoCoreDrawerBody]'
})
export class DrawerBodyDirective {
}
